import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";

export default function useClockSessionMutations(storeId) {
  const app = useRealmApp();

  return {
    addClockSession: useAddClockSession(
      `owner_id=${app.currentUser.id}&store_id=${storeId}`
    ),
    updateClockSession: useUpdateClockSession(
      `owner_id=${app.currentUser.id}&store_id=${storeId}`
    ),
    deleteClockSession: useDeleteClockSession(
      `owner_id=${app.currentUser.id}&store_id=${storeId}`
    ),
  };
}

const AddClockSessionMutation = gql`
  mutation AddClockSession($clockSession: ClockSessionInsertInput!) {
    addedClockSession: insertOneClockSession(data: $clockSession) {
      _id
      userId
      storeId
      status
      type
      chainId
      sessionStart
      sessionEnd
      sessionDuration
      notes
      updated
      updateDatetime
      creationDatetime
    }
  }
`;

const UpdateClockSessionMutation = gql`
  mutation UpdateClockSession(
    $clockSessionId: ObjectId!
    $ownerId: String!
    $updates: ClockSessionUpdateInput!
  ) {
    updatedClockSession: updateOneClockSession(
      query: { _id: $clockSessionId, owner_id: $ownerId }
      set: $updates
    ) {
      _id
      userId
      storeId
      status
      type
      chainId
      sessionStart
      sessionEnd
      sessionDuration
      notes
      updated
      updateDatetime
      creationDatetime
    }
  }
`;

const DeleteClockSessionMutation = gql`
  mutation DeleteClockSession($clockSessionId: ObjectId!, $ownerId: String!) {
    deletedClockSession: deleteOneClockSession(
      query: { _id: $clockSessionId, owner_id: $ownerId }
    ) {
      _id
    }
  }
`;

const ClockSessionFieldsFragment = gql`
  fragment ClockSessionFields on ClockSession {
    _id
    userId
    storeId
    status
    type
    chainId
    sessionStart
    sessionEnd
    sessionDuration
    notes
    updated
    updateDatetime
    creationDatetime
  }
`;

function useAddClockSession(ownerId) {
  const [addClockSessionMutation] = useMutation(AddClockSessionMutation, {
    // Manually save added ClockSessions into the Apollo cache so that ClockSession queries automatically update
    // For details, refer to https://www.apollographql.com/docs/react/data/mutations/#making-all-other-cache-updates
    update: (cache, { data: { addedClockSession } }) => {
      cache.modify({
        fields: {
          clockSessions: (existingClockSessions = []) => [
            ...existingClockSessions,
            cache.writeFragment({
              data: addedClockSession,
              fragment: ClockSessionFieldsFragment,
            }),
          ],
        },
      });
    },
  });
  return async (clockSession) => {
    const {
      data: { addedClockSession },
    } = await addClockSessionMutation({
      variables: {
        clockSession: {
          owner_id: ownerId,
          ...clockSession,
        },
      },
    });
    return addedClockSession;
  };
}

function useUpdateClockSession(ownerId) {
  const [updateClockSessionMutation] = useMutation(UpdateClockSessionMutation);
  const client = useApolloClient();
  //
  return useCallback(
    async (clockSession, updates) => {
      console.log("🚀 ~ return ~clockSession updates:", clockSession, updates);
      const { data } = await updateClockSessionMutation({
        variables: { clockSessionId: clockSession._id, ownerId, updates },
      });
      const { updatedClockSession } = data;
      client.cache.evict({
        // clear this the cache type
        query: "GetClockSessionDate",
      });

      return updatedClockSession;
    },
    [client, updateClockSessionMutation]
  );
}

function useDeleteClockSession(ownerId) {
  const [deleteClockSessionMutation] = useMutation(DeleteClockSessionMutation);
  const client = useApolloClient();

  return useCallback(
    async (clockSession) => {
      const {
        data: { deletedClockSession },
      } = await deleteClockSessionMutation({
        variables: { clockSessionId: clockSession._id, ownerId },
      });
      client.cache.evict({
        // clear this the cache type
        query: "GetClockSessionDate",
      });
      return deletedClockSession;
    },
    [client, deleteClockSessionMutation]
  );

  // const [deleteClockSessionMutation] = useMutation(DeleteClockSessionMutation, {
  //   update: (cache, { data: { deletedClockSession } }) => {
  //     cache.modify({
  //       fields: {
  //         clockSessions: (existingClockSessions = [], { readField }) =>
  //           existingClockSessions.filter(
  //             (ref) => deletedClockSession._id !== readField("_id", ref)
  //           ),
  //       },
  //     });
  //   },
  // });
  // return async (clockSession) => {
  //   const {
  //     data: { deletedClockSession },
  //   } = await deleteClockSessionMutation({
  //     variables: { clockSessionId: clockSession._id, ownerId },
  //   });
  //   return deletedClockSession;
  // };
}
